import { ActionTree } from 'vuex';
import { QuerySignalsState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { GetNextQueriesResultsAction } from './actions/get-next-queries-results.action';
import { GetQuerySignalsAction } from './actions/get-query-signals.action';

export const QUERY_SIGNALS_ACTIONS: ActionTree<QuerySignalsState, RootStoreState> = {
  ...new GetQuerySignalsAction().actions,
  ...new GetNextQueriesResultsAction().actions
};
